import { render, staticRenderFns } from "./MainLogo.vue?vue&type=template&id=5dbd9c04&scoped=true&"
import script from "./MainLogo.vue?vue&type=script&lang=js&"
export * from "./MainLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd9c04",
  null
  
)

export default component.exports